export class Model {
    public build (o: Object): any {
        for (let field in o)
        {
            this[field] = o[field];            
        }

        return this;
    }

    protected twoDigits (n: number): string {
        return (n < 10) ? `0${n}` : `${n}`;
    }

    /** Normalize date-like value to ISO 8601 string for API compatibility. */
    protected toIsoDateString(v: any): string | undefined {
        if (v == null) return v;
        if (v instanceof Date) return v.toISOString();
        if (typeof v === 'string') {
            const d = new Date(v);
            return !isNaN(d.getTime()) ? d.toISOString() : v;
        }
        return v;
    }
}
